(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial"] && !Shopify.designMode) return;
  try {
    
  // countdown timer for any guarantee blocks
  document.querySelectorAll('.adv__timer').forEach(function (el) {
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
    var clock = el.querySelector('.adv__timer-clock');
    if (!clock) return;
    var end = Date.now() + mins * 60000;
    function tick() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
